import React from 'react';
import '../../styles/components/BackgroundAnimation.css';

const BackgroundAnimation = () => {
  return (
    <div className="background-animation">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
      </div>
      <div className="grid-overlay"></div>
    </div>
  );
};

export default BackgroundAnimation; 